<template>

    <div class="page-content" style="width: 100%">
       

            <div v-if="pgLoading" class="col-12 text-center" style="width:100%">
                <span 
                    class="spinner-grow spinner-grow-sm mr-1" 
                    role="status" 
                    aria-hidden="true">
                </span>
            </div>

            <div v-if="!pgLoading" style="margin-top: -80px;">
                <div class="table-responsive">
                    <table class="table align-middle table-nowrap table-check">
                        <thead class="table-dark">
                                <tr>
                                    <th 
                                        style="width: 5%" class="text-center">
                                        #
                                    </th>

                                    <th 
                                        style="width: 15%"
                                        class="align-middle font-weight-500 text-center"
                                        :class="[($i18n.locale == 'ar') 
                                                    ? 'hacen_algeria font-size-16' 
                                                    : 'font-size-14']">
                                        {{ title }}
                                    </th>

                                    <th 
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar') 
                                                ? 'hacen_algeria font-size-16 ' 
                                                : 'font-size-14'">
                                        {{ $t('app.date') }} 
                                    </th>

                                    <th 
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar') 
                                                ? 'hacen_algeria font-size-16 ' 
                                                : 'font-size-14'">
                                        {{ $t('app.status') }}
                                    </th>

                                    <th 
                                        style="width: 15%"
                                        class="align-middle text-center font-weight-500"
                                        :class="($i18n.locale == 'ar') 
                                                ? 'hacen_algeria font-size-16' 
                                                : 'font-size-14'">
                                        {{ $t('app.actions') }}
                                    </th>
                                </tr>
                            </thead>

                            <tbody v-if="!pgLoading && !items.length" c>
                                <tr>
                                    <td 
                                        colspan="6" 
                                        class="text-center"
                                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''">
                                        <span>{{ $t('app.no_data') }}</span>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody v-if="!pgLoading && items.length">
                                <tr v-for="(item, idx) in items" :key="idx">
                                    <td class="text-center">{{ idx+1 }}</td>

                                    <td
                                        class="text-center"
                                        :class="($i18n.locale == 'ar') 
                                                ? 'hacen_algeria font-size-16'
                                                : '' ">
                                        <router-link 
                                            v-if="permissions.edit"
                                            :to="{ name: 'edit-'+refs, params:{id: item.encrypt_id}}"
                                            class="default-color">
                                            {{ ($i18n.locale == 'ar') ? item.ar.title : item.en.title }}
                                        </router-link>

                                        <span v-if="!permissions.edit">
                                            {{ ($i18n.locale == 'ar') ? item.ar.title : item.en.title }}
                                        </span>
                                    </td>

                                    <td class="text-center">{{ item.date }}</td>

                                    <td class="text-center">
                                        <label v-if="item.status == 0"
                                            class="badge rounded-pill badge-md badge-soft-default"
                                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''"
                                            style="padding: 10px">
                                                -
                                        </label>
                                        <label v-if="item.status == 1"
                                            class="badge rounded-pill badge-md badge-soft-success"
                                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''"
                                            style="padding: 10px"
                                            v-html="$t('app.approved')">
                                        </label>
                                        <label v-if="item.status == 2"
                                            class="badge rounded-pill badge-md badge-soft-danger"
                                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-14' : ''"
                                            style="padding: 10px"
                                            v-html="$t('app.unapproved')">
                                        </label>
                                    </td>

                                    <td class="text-center">
                                        <button 
                                                v-if="permissions.edit"
                                                type="button"
                                                @click="editItem(item.encrypt_id)"
                                                class="btn btn-success btn-rounded btn-sm ml-1"
                                                style="width: 32px;height:32px;padding:0;margin-left:5px"
                                                title="Edit">
                                                <i class="mdi mdi-pencil font-size-16"></i>
                                            </button>
                                            <button 
                                                type="button"
                                                v-if="!item.loading && permissions.delete"
                                                @click="item.loading=true; deleteItem(item.encrypt_id);"
                                                class="btn btn-danger btn-rounded btn-sm ml-1"
                                                style="width: 32px;height:32px;padding:0"
                                                title="Delete">
                                                <i class="mdi mdi-delete font-size-16"></i>
                                            </button>
                                            <span v-if="!permissions.edit && !permissions.delete">
                                                <span 
                                                    class="badge rounded-pill badge-md badge-soft-danger"
                                                    style="padding: 10px">
                                                    {{ $t('view.noPermissionGranted') }}
                                                </span>
                                            </span>
                                            <span v-if="item.loading">
                                                <span 
                                                    class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </span>
                                    </td>
                                </tr>
                            </tbody>
                    </table>
                </div>

                <p></p>
                <Pagination 
                    v-if="!pgLoading"
                    :items="items"
                    :pageCount="pageCount"
                    v-on:pageChange="handelPageChange">
                </Pagination>

            </div>


        
    </div>

</template>

<script>
import iziToast from 'izitoast';

export default {
    name: 'MinTable',
    props: [
        'title',
        'refs',
    ],
    components: {
        Pagination: () => import('@/components/Pagination.vue')
    },
    data(){
        return {    
            // auth
            auth: {
                role: '',
                access_token: '',
            },
            pgLoading: true,
            items: [],
            permissions: {
                add: false,
                edit: false,
                delete: false
            },

            total: 0,
            page: 1, 
            perPage: 10,
            pageCount: 10,
        }
    },
    watch: {},
    mounted() {},
    created() {
        // AccessToken & Role
        if(localStorage.getItem('access_token')) {
            this.auth.access_token = localStorage.getItem('access_token');
        }
        if(localStorage.getItem('role')) {
            this.auth.role = localStorage.getItem('role');
        }

        this.fetchData();
    },
    methods: {
        // fetch Row
        fetchData() {
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/'+this.refs,
                method: 'GET',
                data: {}
            }
            this.axios(options)
            .then(res => {
                this.pgLoading = false;
                this.items = res.data.data.rows;
                this.total = res.data.data.paginate.total;
                this.permissions = res.data.data.permissions;
                this.paginate = res.data.data.paginate;

                if(res.data.data.paginate.total) {
                    this.pageCount = Math.ceil(res.data.data.paginate.total / this.perPage);
                }
            })
            .catch(err => {

                // 403 Forbidden
                if(err.response && err.response.status == 401) {
                    this.clearLocalStorage();
                    this.$router.push({ name: 'login' });
                } else if(err.response && err.response.status == 403) {
                    this.$router.push({ name: 'forbidden' });
                } else {
                    this.btnLoading = false;
                    iziToast.warning({
                        icon: 'bx bx-angry',
                        title: '',
                        message: (err.response) ? err.response.data.message : ''+err
                    });
                }

            })
            .finally(() => {});
        },


        // clear Local Storage
        clearLocalStorage() {
            localStorage.removeItem('access_token');
            localStorage.removeItem('avatar');
            localStorage.removeItem('username');
            localStorage.removeItem('encrypt_id');
            localStorage.removeItem('role');
        },

        // Handle Change from child components
        handelPageChange(event) {
            this.page = event;
            this.fetchData();
        },

        deleteItem(id) {
            if(confirm('Are you sure?')) {
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer `+this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/'+this.refs+'/'+id,
                    method: 'DELETE',
                    data: {},
                }
                this.axios(options)
                .then(() => {
                    this.fetchData(true); 
                    iziToast.success({
                        icon: 'bx bx-wink-smile',
                        title: '',
                        message: 'تم الحذف بنجاح',
                    }); 
                })
                .catch(err => {
                    this.fetchData(true); 
                    iziToast.error({
                        icon: 'bx bx-angry',
                        title: '',
                        message: (err.response) ? err.response.data.message : ''+err
                    });
                })
                .finally(() => {});
            } else { 
                // in case pressed cancel
                this.fetchData(true); 
            }
        },

        editItem(id) {
            this.$router.push({ name: 'edit-'+this.refs, params:{id: id} })
        },


    },
}
</script>
